import util from '../util'

let controller = 'ParceiroAgencias'
export default Object.assign({}, util.GetCrud(controller, null))
